export default "__VITE_ASSET__B7nD4fWA__"